import { CHANNEL_MAP } from './Icons';
import styles from './ChannelBadge.module.css';

export default function ChannelBadge({ type }) {
  const ch = CHANNEL_MAP[type];
  if (!ch) return null;
  const { label, Icon, className } = ch;
  return (
    <span className={`${styles.badge} ${styles[className.replace('ch-badge--', '')]}`}>
      <Icon size={10} />
      {label}
    </span>
  );
}
